module.exports = __webpack_public_path__ + "static/media/turnRight.d78fe264.svg";